/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */

export type NegativeOrPositiveDistributionTransactionCodeNamesEnum = typeof NegativeOrPositiveDistributionTransactionCodeNamesEnum[keyof typeof NegativeOrPositiveDistributionTransactionCodeNamesEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NegativeOrPositiveDistributionTransactionCodeNamesEnum = {
  'Fund_Distribution_-_Placement_Fees': 'Fund Distribution - Placement Fees',
  'Fund_Distribution_-_Excess_Organization_Costs': 'Fund Distribution - Excess Organization Costs',
  'Fund_Distribution_-_Corporate_Tax_Expense_Holdback': 'Fund Distribution - Corporate Tax Expense Holdback',
  'Fund_Distribution_-_Other_Expense_Holdback': 'Fund Distribution - Other Expense Holdback',
  'Fund_Distribution_-_(Blocker)_Other_Expense_Holdback': 'Fund Distribution - (Blocker) Other Expense Holdback',
  'Fund_Distribution_-_(Blocker)_Expense_Holdback_-_Return_of_Capital': 'Fund Distribution - (Blocker) Expense Holdback - Return of Capital',
  'Fund_Distribution_-_(Blocker)_Expense_Holdback_-_Realized_Gain': 'Fund Distribution - (Blocker) Expense Holdback - Realized Gain',
  'Fund_Distribution_-_(Blocker)_Expense_Holdback_-_Operating_Income': 'Fund Distribution - (Blocker) Expense Holdback - Operating Income',
} as const;
